<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iiwHG2/tc-custom/9781910690932.jpg?1700549154833" alt="This image is the cover for the book Billy Bishop VC: Lone Wolf Hunter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Billy Bishop VC: Lone Wolf Hunter
      </h1>
      <p class="bookDescription body article font2">
        <b>A “superb” look at one of the Great War’s most storied combat pilots and his legendary solo missions, with never-before-published photos (Barrett Tillman).</b><br/>  <br/> William Avery Bishop is recognized as the British Empire’s highest-scoring WWI ace, credited with seventy-two combat victories. Overall, he ranked behind only Manfred von Richthofen and René Fonck.<br/>  <br/> This remarkable man’s story—his personal courage, daring, and superior marksmanship—has been detailed in books and articles, but here author Peter Kilduff investigates the untold story, bringing new light to missions and kills that have been previously steeped in controversy through evenhanded, thorough research and forensic evidence. As so many of Bishop’s victories were achieved during solo combat, the author examines and scrutinizes German, British, and Canadian archival sources, Bishop’s private correspondence, and accounts by friends and foes. Such an approach provides as complete an account as possible, in a valuable work featuring many previously unpublished photographs.<br/>  <br/> “Kilduff is not the first to conduct such an inquiry into Bishop’s claim of 72 victories, but his book is by far the best researched . . . expertly laid out, with photos of the aircraft mentioned by Bishop, particularly the German types. Kilduff has done a marvelous and subtle job of showing how a real hero became larger than life.” —<i>Aviation History</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Kilduff
      </h2>
      
      <p class="authorDescription body article">Peter Kilduff has been studying and researching aviation history for over fifty years. He was a journalist and professional communicator for over forty years, and retired as director of university relations at his alma mater Central Connecticut State University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      USA
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?324e0c13